export default {
  title: {
    en: 'Success!',
  },
  text: {
    en: 'Your message has been sent',
  },
  ok: {
    en: 'Okay',
  },
}
